// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.three-gradient {
  position: relative;
  width: 100%;
  height: 100%;
}

.overlay-container {
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.three-gradient .wifi {
  position: absolute;
  left: -5vw;
  top: 0vh;
  height: 113vh;
}

.three-gradient .sim {
  position: absolute;
  left: 56vw;
  top: 3vw;
  height: 128vh;
}

.renderer-container {
  position: fixed;
  width:100%;
  height:100%;
  z-index: 0;
  overflow: hidden;
}

.renderer-container canvas {
  /*filter:blur(4px)*/
}

.child-container {
  width:100%;
  height:100%;
  position: relative;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./views/shared/ThreeGradient/ThreeGradient.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,KAAK;EACL,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":[".three-gradient {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.overlay-container {\r\n  position: absolute;\r\n  top:0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.three-gradient .wifi {\r\n  position: absolute;\r\n  left: -5vw;\r\n  top: 0vh;\r\n  height: 113vh;\r\n}\r\n\r\n.three-gradient .sim {\r\n  position: absolute;\r\n  left: 56vw;\r\n  top: 3vw;\r\n  height: 128vh;\r\n}\r\n\r\n.renderer-container {\r\n  position: fixed;\r\n  width:100%;\r\n  height:100%;\r\n  z-index: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.renderer-container canvas {\r\n  /*filter:blur(4px)*/\r\n}\r\n\r\n.child-container {\r\n  width:100%;\r\n  height:100%;\r\n  position: relative;\r\n  z-index: 1;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
